import React from 'react';
import styled from 'styled-components';
import { map } from 'lodash';
import { number, array, string, oneOfType } from 'prop-types';
import IconContainer from '../IconContainer';
import Icon from '../Icon';
import Text from '../Text';
import Number from '../Number';

const TR = styled.tr`
  background-color: #f4f4f4;
`;

const TD = styled.td`
  padding: 3px 10px !important;
`;

const ExcessContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const ExcessTotal = ({ item, ...props }) => {
    return (
        <ExcessContainer {...props}>
            <IconContainer color='#db5959' size={14} style={{ marginRight: 5 }}>
                <Icon name={item < 0 ? 'minus' : 'plus'} size={8} color='#ffffff' />
            </IconContainer>
            <Text size={11} color='#db5959' strong text={<Number value={item} />} />
        </ExcessContainer>
    );
};

ExcessTotal.propTypes = {
    item: oneOfType([string, number])
};
const ExcessRow = ({ excess, columns, ...props }) => (
    <>
        { excess === 0 ? null : (
            <TR>
                { map(columns, (item, index) => (
                    <TD key={index}>
                        { (item > 0 || item < 0) && (
                            <ExcessTotal item={item} {...props} />
                        )}
                    </TD>
                ))}
            </TR>)
        }
    </>
);

ExcessRow.propTypes = {
    excess: oneOfType([string, number]),
    columns: array
};

ExcessRow.defaultProps = {
    excess: 0,
    columns: []
};

export default ExcessRow;
